export default "__VITE_ASSET__f34080a2__"